'use client'

import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogOverlay,
  DialogPortal,
  DialogTitle,
  DialogTrigger,
} from '@radix-ui/react-dialog'

/**
 * @see {@link https://www.radix-ui.com/primitives/docs/components/dialog#root}
 */
export const DialogPrimitive = Dialog

/**
 * @see {@link https://www.radix-ui.com/primitives/docs/components/dialog#close}
 */
export const DialogPrimitiveClose = DialogClose

/**
 * @see {@link https://www.radix-ui.com/primitives/docs/components/dialog#content}
 */
export const DialogPrimitiveContent = DialogContent

/**
 * @see {@link https://www.radix-ui.com/primitives/docs/components/dialog#description}
 */
export const DialogPrimitiveDescription = DialogDescription

/**
 * @see {@link https://www.radix-ui.com/primitives/docs/components/dialog#overlay}
 */
export const DialogPrimitiveOverlay = DialogOverlay

/**
 * @see {@link https://www.radix-ui.com/primitives/docs/components/dialog#portal}
 */
export const DialogPrimitivePortal = DialogPortal

/**
 * @see {@link https://www.radix-ui.com/primitives/docs/components/dialog#title}
 */
export const DialogPrimitiveTitle = DialogTitle

/**
 * @see {@link https://www.radix-ui.com/primitives/docs/components/dialog#trigger}
 */
export const DialogPrimitiveTrigger = DialogTrigger
